import { render, staticRenderFns } from "./PublishModal.vue?vue&type=template&id=58e3d3b5&scoped=true&"
import script from "./PublishModal.vue?vue&type=script&lang=js&"
export * from "./PublishModal.vue?vue&type=script&lang=js&"
import style0 from "./PublishModal.vue?vue&type=style&index=0&id=58e3d3b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e3d3b5",
  null
  
)

export default component.exports